/* eslint-disable react/no-danger */
import { memo } from 'react';
import { GetServerSideProps } from 'next';
import { END } from 'redux-saga';
import { wrapper, SagaStore } from 'store';

import { validatePark } from '..';
import NewsPage from '@containers/News';
import { GET_CATE_NEWS, GET_HOT_NEWS } from '@containers/News/slice';
import { GET_NEWS } from '@containers/Home/slice';

function NewsContainer({ park }: { park: string }) {
  return <NewsPage park={park} />;
}

export const getServerSideProps: GetServerSideProps =
  wrapper.getServerSideProps(store => async ({ params }) => {
    const { park } = params || {};
    const isValidPark = await validatePark(park);
    if (!isValidPark) {
      return {
        notFound: true,
      };
    }
    store.dispatch(GET_HOT_NEWS({ park }));
    store.dispatch(GET_CATE_NEWS({ park }));
    store.dispatch(GET_NEWS({ park }));
    store.dispatch(END);
    await (store as SagaStore).sagaTask?.toPromise();

    return {
      props: {
        park,
      },
    };
  });

export default memo(NewsContainer);
